//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../Annotations/Annotations.LeaderBuilder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../no/SelectNXObject.js";
import "../no/Annotations.js";
import "../no/SelectObject.js";
let d=[[[1,"AnnotLeader",0,"Annotations.LeaderBuilder",0],[1,"CompOrigin",0,"Annotations.OriginBuilder",0],[0,"EnumType",1,0],[1,"ObjectSelection",0,"SelectNXObject",0]],[],[]];
SPLM.Formboard.ObjectAttributeReferenceBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.ObjectAttributeReferenceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.ObjectAttributeReferenceBuilder.LeaderType = Object.freeze({
    "None" : "None", "SingleLocation" : "SingleLocation", "StartandEndLocations" : "StartandEndLocations"});

export default SPLM;